// Media page slider

$('.centr-media').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  prevArrow:" <img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0564/3272/2001/files/arrow_forward_24px.png?v=1696329762'>",
  nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0564/3272/2001/files/arrow_forward_24px_4b0ae87e-8a9d-428b-9a63-594857dcb920.png?v=1696329915'>",
responsive: [
      {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false
      }
    },
  ]
});

// End



// jQuery(document).ready(function(){
//   jQuery("input").attr("placeholder", "ENTER A LOCATION");
// })


(function ($) {
  "use strict";

  $(document).ready(function($){

    const queryParams = new URLSearchParams(window.location.search);

    // 1. iterate over the keys
    const contains_selling_plan = queryParams.has('selling_plan');
    
    function changePriceDelayonLoad() {
      if (contains_selling_plan) {

        function changeSubPrice(){
          var newPrice2 = $(".subscription-radio span.rc-radio__price").text();
          $(".product .price__container .price__regular .price-item").text(newPrice2);
        }
        setTimeout(changeSubPrice, 1000);
  
    }
  }

    setTimeout(changePriceDelayonLoad, 1000);

    function changePriceDelay() {
      $('input[type=radio][name=purchaseOption]').change(function() {
        if (this.value == 'onetime') {

          function oneTimeChange(){
            var newPrice1 = $(".onetime-radio span.rc-radio__label span:last-child").text();
            $(".product .price__container .price__regular .price-item").text(newPrice1);
          }
          setTimeout(oneTimeChange, 100);
    
        }
        else if (this.value == 'subscription') {
    
          function changeSubPrice(){
            var newPrice2 = $(".subscription-radio span.rc-radio__price").text();
            $(".product .price__container .price__regular .price-item").text(newPrice2);
          }
          setTimeout(changeSubPrice, 100);
    
        }
      });
    }

    changePriceDelay();

    setTimeout(changePriceDelay, 1000);


  });

})(jQuery);



if (navigator.geolocation) {
  // override getCurrentPosition() method
  navigator.geolocation.getCurrentPosition = function(success, error) {
    success({ 
      coords: {
        latitude: 37.7749, // default latitude
        longitude: -122.4194 // default longitude
      }
    });
  };
}


setTimeout(() => {
  if(document.getElementsByClassName('rc-radio__label').length>0){
    var a = document.getElementsByClassName('rc-radio__label');
    var c = a[0].innerHTML.split(' ');
    a[0].innerHTML = "";
    var e = document.createElement('span');
    a[0].appendChild(e);
    e.innerHTML = c[0] + ' ' + c[1]
    var d = document.createElement('span')
    a[0].appendChild(d);
    d.innerHTML = c[2];
  }
}, 1000)


// OPTIC LANDING PAGE JS START
$('.optic_testimonials_wrapper').slick({
  arrows:false,
  dots: true,
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        fade:true,
      }
    }
  ]
});

if ($(window).width() < 768) {
$('.optic_gallary_wrapper,.ready_to_mix_products_grid').slick({
  arrows:false,
  dots: true,
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});
}

$('.optic_faqs_heading').click(function() {
    $(this).next().slideToggle();
    $(this).parent().toggleClass('faqopen');
    $(this).parents('.optic_faqs_item').siblings().find('.optic_faqscontent').removeClass('faqopen');
    $(this).parents('.optic_faqs_item').siblings().find('.optic_faqs_subtext').slideUp();
})
// OPTIC LANDING PAGE JS END
